export default {
  cardItemBackground: '#161616',
  label: '#9B9B9B',
  green: '#21C756',
  blue: '#2580AC',
  orange: '#F5A123',
  red: '#EB6565',
  border: '#2A2A2A',
  grayText1: '#9B9B9B',
};
